import { action, makeAutoObservable, toJS } from "mobx";

export class GovermentConfigStore {
  govtConfigData = {};
  surveys = [];
  constructor() {
    makeAutoObservable(this);
  }
  @action
  initializeStore(data) {
    this.govtConfigData = { ...data };
  }
  @action
  setSurveys(data) {
    this.surveys = data;
  }
}
